import { forwardRef, useId } from 'react';

/** Canonical purpose and density; callers own confirmations and gameplay. */
const Button = forwardRef(function Button({
  variant = 'primary', size = 'standard', busy, busyLabel = 'Working…', disabled = false,
  disabledReason, children, className = '', type = 'button',
  'aria-describedby': describedBy, 'aria-label': ariaLabel, ...props
}, ref) {
  const reasonId = useId();
  const reason = disabled && disabledReason;
  const button = <button {...props} ref={ref} type={type}
    className={`fc-button fc-button--${variant} fc-button--size-${size} ${className}`}
    disabled={disabled || busy} aria-busy={busy || undefined} data-reserves-busy={busy !== undefined || undefined}
    aria-label={busy ? busyLabel : ariaLabel}
    aria-describedby={[describedBy, reason && reasonId].filter(Boolean).join(' ') || undefined}>
    <span className="fc-button__label" aria-hidden={busy || undefined}>{children}</span>
    <span className="fc-button__busy" aria-hidden="true">{busyLabel}</span>
  </button>;
  return reason ? <div className="fc-action-with-reason">{button}
    <p id={reasonId} className="fc-helper">{disabledReason}</p></div> : button;
});

export default Button;
